import { ColumnDefinition, JsonValue } from 'src/types/tableDataSet'
import { formatIfIsoDate } from './dateUtils'

export const getExcelColumnLabel = (index: number): string => {
  let label = ''
  let i = index
  while (i >= 0) {
    label = String.fromCharCode((i % 26) + 65) + label
    i = Math.floor(i / 26) - 1
  }
  return label
}

const renderNumber = (val: string | number) => {
  const num = Number(val)
  if (Number.isNaN(num)) return <span className="cell-default">{val}</span>
  return <span className="cell-number">{num.toLocaleString('es-ES')}</span>
}

const renderDate = (val: string, type: 'date' | 'time' | 'datetime') => (
  <span className={`cell-date type-${type}`}>{formatIfIsoDate(val)}</span>
)

const renderBoolean = (val: boolean) => (
  <span className={`cell-bool ${val ? 'true' : 'false'}`}>
    <span className={`icon icon-${val ? 'circle-check' : 'cross'}`} />
  </span>
)

const renderJson = (val: JsonValue) => (
  <code className="cell-json">{JSON.stringify(val)}</code>
)

const renderDefault = (val: string | number) => (
  <span className="cell-default">{val}</span>
)

const renderEmpty = () => <span className="cell-empty">-</span>

export const getCellContent = (val: JsonValue, colDef: ColumnDefinition) => {
  if (val === null || val === undefined) return renderEmpty()

  switch (colDef.uiType) {
    case 'number':
      return renderNumber(val as string | number)
    case 'bool':
      return renderBoolean(val as boolean)
    case 'date':
    case 'time':
    case 'datetime':
      return renderDate(val as string, colDef.uiType)
    case 'json':
    case 'geojson':
      return renderJson(val)
    case 'string':
    default:
      return renderDefault(val as string | number)
  }
}
